import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgWarningAltFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 16 16",
	fill: "inherit",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.0556 2.76215L1.44595 12.5467C1.13481 13.0894 0.979233 13.3608 1.00223 13.5835C1.02228 13.7777 1.12307 13.9542 1.2795 14.0691C1.45884 14.2008 1.76935 14.2008 2.39035 14.2008H13.6096C14.2307 14.2008 14.5412 14.2008 14.7205 14.0691C14.8769 13.9542 14.9777 13.7777 14.9978 13.5835C15.0208 13.3608 14.8652 13.0894 14.5541 12.5467L8.9444 2.76215C8.63437 2.22139 8.47935 1.951 8.27711 1.86019C8.1007 1.78098 7.8993 1.78098 7.72289 1.86019C7.52065 1.951 7.36563 2.22139 7.0556 2.76215ZM8.69321 6.52548C8.69321 6.13637 8.38211 5.82093 7.99836 5.82093C7.6146 5.82093 7.3035 6.13637 7.3035 6.52548V9.09315C7.3035 9.48226 7.6146 9.7977 7.99836 9.7977C8.38211 9.7977 8.69321 9.48226 8.69321 9.09315V6.52548ZM7.99834 12.2212C8.40768 12.2212 8.73951 11.8847 8.73951 11.4697C8.73951 11.0546 8.40768 10.7182 7.99834 10.7182C7.589 10.7182 7.25716 11.0546 7.25716 11.4697C7.25716 11.8847 7.589 12.2212 7.99834 12.2212Z"
	})
});
export default SvgWarningAltFilled;
